import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { Form, Select, Card, Switch, Spin, Row, Col } from 'antd';
import { ApiCaller, Utils } from '../../config';

const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const CompanyWorkWeekSettings = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const [useGlobal, setUseGlobal] = useState(true);
    const [form] = Form.useForm();

    useEffect(() => {
        const fetchSettings = async () => {
            setLoading(true);
            try {
                const res = await ApiCaller.Get('/guard-company/work-week-settings');
                const data = res.data?.data || res.data;
                const companyData = data?.company || data;
                if (companyData) {
                    const usesGlobal = companyData.usesGlobalDefaults !== false;
                    setUseGlobal(usesGlobal);
                    form.setFieldsValue({
                        usesGlobalDefaults: usesGlobal,
                        workWeekStartDay: companyData.workWeekStartDay || 'sunday',
                        workWeekEndDay: companyData.workWeekEndDay || 'saturday',
                    });
                }
            } catch (e) {
                // Ignore error if endpoint doesn't exist yet
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, [form]);

    const onValuesChange = (changedValues) => {
        if ('usesGlobalDefaults' in changedValues) {
            setUseGlobal(changedValues.usesGlobalDefaults);
        }
    };

    useImperativeHandle(ref, () => ({
        save: async () => {
            try {
                const values = await form.validateFields();
                const payload = values.usesGlobalDefaults
                    ? { usesGlobalDefaults: true }
                    : { usesGlobalDefaults: false, workWeekStartDay: values.workWeekStartDay, workWeekEndDay: values.workWeekEndDay };

                await ApiCaller.Patch('/guard-company/work-week-settings', payload);
                return true;
            } catch (e) {
                if (e.errorFields) {
                    return false;
                }
                Utils.showMessage('error', e?.response?.data?.message || 'Failed to update company work week settings');
                throw e;
            }
        }
    }));

    if (loading) return <Spin />;

    return (
        // <Card title="Company Work Week Override" bordered={false} style={{ maxWidth: '100%' }}>
        <Form form={form} layout="vertical" onValuesChange={onValuesChange} initialValues={{ usesGlobalDefaults: true }}>
            <Form.Item name="usesGlobalDefaults" valuePropName="checked" label="Use Global Work Week Defaults">
                <Switch />
            </Form.Item>

            {!useGlobal && (
                <Row gutter={24}>
                    <Col xs={24} md={12}>
                        <Form.Item name="workWeekStartDay" label="Custom Work Week Start Day" rules={[{ required: true }]}>
                            <Select>
                                {daysOfWeek.map(day => <Select.Option key={day} value={day.toLowerCase()}>{day}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item name="workWeekEndDay" label="Custom Work Week End Day" rules={[{ required: true }]}>
                            <Select>
                                {daysOfWeek.map(day => <Select.Option key={day} value={day.toLowerCase()}>{day}</Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            )}
        </Form>
        // </Card>
    );
});

export default CompanyWorkWeekSettings;
